var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomAppIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1256_11981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0V0Z",
    fill: "url(#paint0_linear_1256_11981)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16307 13.8371H4.20923C4.01538 13.8371 3.83077 13.7356 3.73846 13.5602C3.63692 13.3571 3.67384 13.1171 3.83077 12.9602L5.88923 10.9018H4.4123C4.00615 10.9018 3.67384 10.5694 3.67384 10.1633H6.40615C6.6 10.1633 6.78461 10.2648 6.87692 10.4402C6.97846 10.6433 6.94154 10.8833 6.78461 11.0402L4.72615 13.0987H6.43384C6.84 13.0987 7.16307 13.431 7.16307 13.8371ZM18.8954 10.1079C18.4708 10.1079 18.0923 10.2925 17.8246 10.5879C17.5662 10.2925 17.1785 10.1079 16.7538 10.1079C15.9692 10.1079 15.3231 10.7818 15.3231 11.5664V13.8371C15.7292 13.8371 16.0615 13.5048 16.0615 13.0987V11.5571C16.0615 11.1787 16.3569 10.8556 16.7354 10.8464C17.1323 10.8279 17.4646 11.151 17.4646 11.5479V13.1079C17.4646 13.5141 17.7969 13.8464 18.2031 13.8464V11.5664C18.2031 11.1879 18.4985 10.8648 18.8769 10.8556C19.2738 10.8371 19.6062 11.1602 19.6062 11.5571V13.1171C19.6062 13.5233 19.9385 13.8556 20.3446 13.8556V11.5848C20.3262 10.7818 19.68 10.1079 18.8954 10.1079ZM10.8831 12.0002C10.8831 13.0433 10.0338 13.8925 8.99077 13.8925C7.94769 13.8925 7.09846 13.0433 7.09846 12.0002C7.09846 10.9571 7.94769 10.1079 8.99077 10.1079C10.0338 10.1079 10.8831 10.9571 10.8831 12.0002ZM10.1446 12.0002C10.1446 11.3633 9.62769 10.8464 8.99077 10.8464C8.35384 10.8464 7.83692 11.3633 7.83692 12.0002C7.83692 12.6371 8.35384 13.1541 8.99077 13.1541C9.62769 13.1541 10.1446 12.6371 10.1446 12.0002ZM14.9631 12.0002C14.9631 13.0433 14.1138 13.8925 13.0708 13.8925C12.0277 13.8925 11.1785 13.0433 11.1785 12.0002C11.1785 10.9571 12.0277 10.1079 13.0708 10.1079C14.1138 10.1079 14.9631 10.9571 14.9631 12.0002ZM14.2246 12.0002C14.2246 11.3633 13.7077 10.8464 13.0708 10.8464C12.4338 10.8464 11.9169 11.3633 11.9169 12.0002C11.9169 12.6371 12.4338 13.1541 13.0708 13.1541C13.7077 13.1541 14.2246 12.6371 14.2246 12.0002Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1256_11981",
    x1: 3.80384,
    y1: 26.1962,
    x2: 20.1962,
    y2: -2.19616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0845BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0B5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6122,
    stopColor: "#1463FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7951,
    stopColor: "#2C76F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F90EE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1256_11981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomAppIcon);
export default __webpack_public_path__ + "static/media/zoom-app-icon.44103c2c665a8dc207664112544a7834.svg";
export { ForwardRef as ReactComponent };